
        <template>
          <div class="vc-snippet-doc">
            <h1>vue-property-decorator</h1>
<p><code>This library fully depends on vue-class-component, so please read its README before using this library.</code></p>
<p>这个库完全依赖于<code>vue-class-component</code>，所以在使用这个库之前，请阅读它的自述文件。</p>
<p>安装：<code>npm i -S vue-property-decorator</code></p>
<p><code>Usage</code>使用</p>
<p><code>There are several decorators and 1 function (Mixin):</code>-有几种<code>decorator</code>和一个函数(<code>Mixin</code>):</p>
<pre class="hljs"><code>@<span class="hljs-title class_">Prop</span>
@<span class="hljs-title class_">PropSync</span>
@<span class="hljs-title class_">Model</span>
@<span class="hljs-title class_">ModelSync</span>
@<span class="hljs-title class_">Watch</span>
@<span class="hljs-title class_">Provide</span>
@<span class="hljs-title class_">Inject</span>
@<span class="hljs-title class_">ProvideReactive</span>
@<span class="hljs-title class_">InjectReactive</span>
@<span class="hljs-title class_">Emit</span>
@<span class="hljs-title class_">Ref</span>
@VModel
@<span class="hljs-title class_">Component</span> (provided by vue-<span class="hljs-keyword">class</span>-component)
<span class="hljs-title class_">Mixins</span> (the helper <span class="hljs-keyword">function</span> named mixins provided by vue-<span class="hljs-keyword">class</span>-component)
</code></pre>

          </div>
        </template>
        <script>
           
           export default {
           name: 'vc-component-doc',
           components: {
            
           },
           data(){
            return {}
           }
         }
       </script>
       <style lang='scss'>
         
       </style>